import axios from 'axios';
import history from '../../../../history';
import showToaster from '../../../../helpers/toastrMessgaes/showToaster';
import { setLoaderComplete, setLoaderStart } from '../../../../actions/loader/loader';

const mutation = `
mutation addContentPageDetails(
  $id:Int,
  $metaTitle: String,
  $metaDescription: String,
  $pageUrl: String,
  $pageTitle: String,
  $content: String,
  $pageBanner: String
  $dynamicContent:[dynamicContentInputType]
) {
  addContentPageDetails(
    id:$id,
    metaTitle: $metaTitle,
    metaDescription: $metaDescription,
    pageUrl: $pageUrl,
    pageTitle: $pageTitle,
    content: $content,
    pageBanner: $pageBanner
    dynamicContent:$dynamicContent
  ) {
      status
      errorMessage
  }
}
`;

async function submit(values, dispatch) {

  try {
    if (values.content == null || values.content == '<p><br></p>' || values.content == '<p> </p>') {
      showToaster({ messageId: 'addCmsContent', toasterType: 'error' });
      return
    }
    let content = values.content[0]?.content;

    dispatch(setLoaderStart('ContentPageForm'));

    const response = await axios.post('/graphql', {
      query: mutation,
      variables: {
        id: values?.id,
        metaTitle: values?.metaTitle,
        metaDescription: values?.metaDescription,
        pageUrl: values?.pageUrl,
        pageTitle: values?.pageTitle,
        content,
        pageBanner: values?.pageBanner,
        dynamicContent: values?.content
      }
    }, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });

    const { data } = await response?.data;
    dispatch(setLoaderComplete('ContentPageForm'))
    if (data?.addContentPageDetails?.status === 200) {
      showToaster({ messageId: 'updateStatusSuccess', toasterType: 'success' });
      history.push('/siteadmin/contentpage/manage')
    }
    else if (data?.addContentPageDetails?.status !== 200)
      showToaster({ messageId: 'errorMessage', requestContent: data?.addContentPageDetails?.errorMessage, toasterType: 'error' });
    else {
      showToaster({ messageId: 'errorMessage', toasterType: 'error' });
    }
  }
  catch (error) {
    showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
  }
}

export default submit;